import { faker } from '@faker-js/faker'

import { asBuilder } from '../asBuilder'
import { UserServiceOfferUserLog } from '../../contracts/service-offer'

export const getUserServiceOfferUserLog = asBuilder((): UserServiceOfferUserLog => {
  return {
    name: faker.lorem.word(),
    trackingId: faker.string.uuid(),
    type: faker.helpers.arrayElement(['COMPLETE_VIEW', 'CLICK_EVENT']),
    screen: 'SEARCH_EVENT',
    requester: {
      deviceId: faker.string.uuid(),
      memberId: faker.number.int(),
      country: faker.string.uuid(),
    },
    body: {
      request: {
        headers: {
          abtest: {
            'ab-test-key': faker.helpers.arrayElement(['CONTROL', 'A', 'B', 'C', 'D', 'E']),
          },
          'Accept-Language': faker.lorem.word(),
          deviceType: faker.lorem.word(),
          appVersionName: faker.lorem.word(),
        },
      },
      index: faker.number.int(),
      id: faker.number.int(),
      consultation: {
        buttonType: faker.lorem.word(),
      },
      logVersion: faker.string.uuid(),
      keyword: faker.lorem.word(),
    },
    loggedTime: faker.number.int(),
  }
})
